import { useEffect, useRef } from 'react';

/**
 * An ambient light orb that trails the cursor with spring physics.
 * Adds depth and makes the page feel interactive and alive.
 * Respects prefers-reduced-motion (hidden when reduced motion preferred).
 */
const CursorGlow = () => {
  const glowRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const el = glowRef.current;
    if (!el) return;

    let targetX = window.innerWidth / 2;
    let targetY = window.innerHeight / 2;
    let currentX = targetX;
    let currentY = targetY;
    let raf;

    const STIFFNESS = 0.072; // Lower = more lag (dreamier)

    const onMove = (e) => {
      targetX = e.clientX;
      targetY = e.clientY;
    };

    const tick = () => {
      currentX += (targetX - currentX) * STIFFNESS;
      currentY += (targetY - currentY) * STIFFNESS;
      el.style.transform = `translate(${currentX}px, ${currentY}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(tick);
    };

    window.addEventListener('mousemove', onMove);
    tick();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('mousemove', onMove);
    };
  }, []);

  return (
    <div
      ref={glowRef}
      aria-hidden="true"
      className="pointer-events-none fixed top-0 left-0 z-[9] will-change-transform"
      style={{
        width: 480,
        height: 480,
        background: 'radial-gradient(circle, rgba(59,130,246,0.055) 0%, transparent 65%)',
        borderRadius: '50%',
      }}
    />
  );
};

export default CursorGlow;
